// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__W1TTO","disabled":"Button_disabled__DkgJ+","main":"Button_main__LLf6g","subMain":"Button_subMain__35v4k"};